<template>
  <vee-object :title="model.nickname" :enable.sync="model.isUsed" :expand.sync="model.isExpand" :showTitle="showTitle">
    <div class="vee-type-array-header">
      <vee-select v-model="selectType" :options="typeOptions" placeholder="请选择类型"></vee-select>
      <el-button type="primary" size="mini" class="vee-type-array-add-btn" @click="handleAddBtnClick">新增</el-button>
    </div>
    <el-table
      class="vee-type-array-table"
      row-key="__index"
      @expand-change="tableExpandChange"
      :expand-row-keys="expandRowKeys"
      :data="tableDatas">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <VeeLableEditList :model="scope.row" :ignoreKeys="['type']" :parentPropPath="getPropPath(scope.row.props.type.value)"></VeeLableEditList>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <vee-select v-model="scope.row.props.type.value" :options="typeOptions" placeholder="请选择类型" disabled></vee-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200">
        <template slot-scope="scope">
          <div class="vee-type-array-op">
            <el-button type="text" size="mini" @click="handleCopyBtnClick(scope.row)">复制</el-button>
            <el-button type="text" class="vee-danger vve-array-del-btn" size="mini" @click="handleDelBtnClick(scope.row)">删除</el-button>
            <i class="el-icon-top vee-type-array-icon vee-type-array-icon-top" title="向上移动"
              v-show="model.value.indexOf(scope.row) !== 0"
              @click="handleUpMove(scope.row)"></i>
            <i class="el-icon-bottom vee-type-array-icon" title="向下移动"
              v-show="model.value.indexOf(scope.row) !== (total - 1)"
              @click="handleDownMove(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="total > 10"
      class="vee-type-array-pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </vee-object>
</template>

<script>
  import { Table, TableColumn, Button, Pagination, Message } from 'element-ui'
  import VeeObject from '../components/VeeObject'
  import VeeSelect from '../components/VeeSelect'
  import VeeLableEditList from './VeeLabelEditList'
  import cloneDeep from 'lodash/cloneDeep'
  import { mapGetters } from 'vuex'
  import { veeStoreName } from '../store/name'

  export default {
    components: {
      VeeSelect,
      VeeObject,
      VeeLableEditList,
      'ElTable': Table,
      'ElTableColumn': TableColumn,
      'ElButton': Button,
      'ElPagination': Pagination,
    },
    props: {
      model: {
        type: Object,
        default () {
          return {}
        }
      },
      parentPropPath: {
        type: String,
        default: ''
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ...mapGetters(veeStoreName, ['soulFold']),
      typeOptions () {
        const options = Object.keys(this.model.props).map(key => {
          return {
            label: this.model.props[key].nickname,
            value: key,
          }
        })
        return options
      },
      expandRowKeys () {
        // typeof (this.soulFold) === 'boolean' 这个语句没有业务意义
        // 因为isExpand并不会导致expandRowKeys重新计算，引入soldFold，当solFold改变就强制刷新
        return typeof (this.soulFold) === 'boolean' && this.tableDatas.filter(item => item.isExpand).map(item => item.__index)
      },
      tableDatas () {
        const startIndex = (this.currentPage - 1) * this.pageSize
        const tableDatas = this.model.value.slice(startIndex, startIndex + this.pageSize)
        const time = new Date().getTime()
        tableDatas.forEach((item, index) => {
          item.__index = String(time) + String(index)
        })
        return tableDatas
      },
      total () {
        return this.model.value.length
      },
    },
    methods: {
      tableExpandChange (row, arg1, arg2) {
        row.isExpand = !row.isExpand
      },
      getPropPath (type) {
        const path = `${this.model.name}-${type}`
        return this.parentPropPath ? `${this.parentPropPath}.${path}` : path
      },
      handleUpMove (selectItem) {
        const arr = this.model.value
        const index = arr.indexOf(selectItem)
        if (index !== 0) {
          const nextItem = arr.splice(index - 1, 1, selectItem)[0]
          arr.splice(index, 1, nextItem)
        }
      },
      handleDownMove (selectItem) {
        const arr = this.model.value
        const index = arr.indexOf(selectItem)
        if (index !== arr.length - 1) {
          const preItem = arr.splice(index + 1, 1, selectItem)[0]
          arr.splice(index, 1, preItem)
        }
      },
      handleDelBtnClick (item) {
        const index = this.model.value.indexOf(item)
        this.model.value.splice(index, 1)
        if (!this.tableDatas.length && this.currentPage > 1) {
          this.currentPage -= 1
        }
      },
      handleAddBtnClick () {
        if (!this.selectType) {
          return Message.warning('请选择一个类型')
        }
        const newValue = cloneDeep(this.model.props[this.selectType])
        newValue.isUsed = true
        newValue.isExpand = false
        newValue.isMore = false
        // 自动添加类型，保持格式一致
        newValue.props.type = newValue.props.type || {
          desc: "type",
          isUsed: true,
          name: "type",
          nickname: "类型",
          type: "robot",
          value: this.selectType,
        }
        newValue.props.type.value = this.selectType
        this.model.value.push(newValue)
      },
      handleCopyBtnClick (item) {
        const index = this.model.value.indexOf(item)
        this.model.value.splice(index + 1, 0, cloneDeep(item))
      },
      handleCurrentChange (val) {
        this.currentPage = val
      },
      handleSizeChange (val) {
        this.pageSize = val
      }
    },
    data() {
      return {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        selectType: '',
      }
    }
  }
</script>
<style lang="scss">
</style>
